import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';

@Injectable()
export class FormService {

    constructor(
        private http: HttpClient
    ) { }

    getForm(id) {
        return this.http.get(environment.serverUrl + '/taskTemplate/' + id);
    }

    previewForm(formData) {
        return this.http.post(environment.serverUrl + '/task/newpreview/', formData);
    }

    submitForm(formData) {
        return this.http.post(environment.serverUrl + '/task/', formData);
    }

    query(inputData) {
        return this.http.post(environment.serverUrl + '/task/query', inputData);
    }

    getAssets() {
        return this.http.get(environment.serverUrl + '/assets');
    }
}



// WEBPACK FOOTER //
// ./src/app/rFF/form/form.service.ts